<template>
  <PopupContainer style="z-index: 100">
    <div class="card max-h-screen flex flex-col">
      <div class="card-header">
        <p class="card-title h4">Mediendatei auswählen</p>
      </div>
      <div class="card-body flex-grow overflow-y-auto">
        <div class="grid grid-cols-5 max-w-4xl gap-4 overflow-auto">
          <media-card v-for="mediaObject in mediaFiles" :object="mediaObject" delete-disabled
                      @click="$emit('success', mediaObject.ref.fullPath)" />
        </div>
      </div>
      <div class="card-footer">
        <button class="btn" @click="$emit('failure')">Abbrechen</button>
      </div>
    </div>
  </PopupContainer>
</template>
<script>
import PopupContainer from "./gui-components/PopupContainer";
import MediaCard from "./dashboard/MediaCard";
import { filteredMediaFiles } from "@/store/media";

export default {
  components: { MediaCard, PopupContainer },
  props: {
    audio: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    filteredMediaFiles,
    mediaFiles() {
      return this.filteredMediaFiles.filter(mediaFile => {
        if (this.audio)
          return mediaFile.meta.contentType.includes("audio");
        else
          return !mediaFile.meta.contentType.includes("audio");
      });
    }
  }
}
</script>